
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturer-detail",
      function () {
        return require("private-next-pages/manufacturer-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manufacturer-detail"])
      });
    }
  